import React, { Fragment } from 'react'
import moment from 'moment'
import MedicineBox from './MedicineBox'
import withPolyglot from '../../../../common/withPolyglot'

function getAgeDescription (birthday, translate) {
  const patientBirthDay = moment(new Date(birthday))
  const years = moment().diff(patientBirthDay, 'years', false)
  if (years > 1) {
    return translate('numYears', true, 'timing', {smart_count: years})
  } else {
    const months = moment().diff(patientBirthDay, 'months', false)
    if (months > 0) {
      return translate('numMonths', true, 'timing', {smart_count: months})
    } else {
      const days = moment().diff(patientBirthDay, 'days', false)
      return translate('numDays', true, 'timing', {smart_count: days})
    }
  }
}

const SectionTitle = ({line, icon, title1, title2, hideSecondary = true}) => {
  return (
    <div>
      {line ? <hr className='new-section-line' /> : ''}
      {<span data-uk-icon={`icon: ${icon}`} /> || ''}
      <span className='uk-text-medium'>{`${title1} ${title1 !== title2 ? '| ' : ''}`}</span>
      {title1 !== title2
        ? <span className='uk-text-medium uk-text-muted'>{title2}</span>
        : !hideSecondary ? <span className='uk-text-medium uk-text-muted'>{title2}</span> : null
      }
    </div>
  )
}

const ReceiptContent = ({patient, logos, nextImmunizations, immunizations, pathologies, translate, currentLocale}) => {
  const currentDate = moment().format('L')
  return (
    <div className='receipt uk-container uk-container-xsmall'>
      <div className='uk-text-center receipt-title'>
        {translate('vaccineRegistry')} | <span>{currentDate}</span>
      </div>
      <div className='receipt-header uk-flex uk-width-1-1'>
        <div className='uk-text-small uk-width-auto identification-box'>
          <div>
            <span className='uk-text-bold'>{translate('name')}: </span>
            {patient.name}
          </div>
          <div>
            <span className='uk-text-bold'>{translate('birthDate')}: </span>
            {patient.getFormattedBirthDate('pt-PT')}
            <span className='uk-text-bold'> | {translate('age')}: </span>
            {getAgeDescription(patient.birthDate, translate)}
          </div>
          <div>
            <span className='uk-text-bold'>{translate('userNumber')}: </span>
            {patient.id}
          </div>
        </div>
        <div className='receipt-logos uk-width-auto'>
          {logos.map((logo, index) => (
            <img
              key={index}
              className='receipt-logo'
              src={logo.url}
              alt={logo.alt}
              width={logo.width}
              height={logo.height} />
          ))}
        </div>
      </div>
      <div className='next-immunizations'>
        <SectionTitle
          hideSecondary={false}
          line
          title1={translate('nextImmunizations')}
          title2={'Next Immunizations'} />
        <div className='uk-grid uk-child-width-1-4@s uk-child-width-1-2'>
          {
            nextImmunizations.map((data, i) => <NextImmunoBox
              translate={translate}
              key={i}
              data={data}
              locale={currentLocale} />)
          }
        </div>
      </div>
      <SectionTitle
        line
        title1={translate('currentImmunizations')}
        title2='Current Immunizations' />

      {pathologies.map((pathology, i) => {
        if ((pathology.immunizations.length + pathology.recommendations.length) > 0) {
          return <Fragment key={i}>
            <SectionTitle
              icon=''
              title1={translate(pathology.displayKey, true, 'pathologies')}
              title2={translate(pathology.displayKey, true, 'localeIndependent')} />
            <div className='medicine-grid uk-grid uk-grid-small'>
              {
                pathology.immunizations.map((immuno, i) => {
                  const protocolInfo = immuno.protocolInfo.find(info => info.pathology.id === pathology.id)
                  return <MedicineBox
                    key={i}
                    adverse={!!immuno.adverseReactionId}
                    date={immuno.getFormattedDate()}
                    type={immuno.type}
                    sequence={protocolInfo.seqNumber} />
                })
              }
              {
                pathology.recommendations.map((recom, i) => {
                  return <MedicineBox expected key={i} sequence={recom.doseNumber} date={recom.getRecommendedDate()} />
                })
              }
              {/* <MedicineBox name='Vac. Name' date='25/04/2017' /> */}
              {/* <MedicineBox missing name='Vac. Name' date='25/04/2017' /> */}
              {/* <MedicineBox expected name='Vac. Name' date='25/04/2017' /> */}
            </div>
          </Fragment>
        }
        return null
      })
      }
    </div>
  )
}

function formatDate (date, locale = 'pt-PT') {
  let localLocale = moment(new Date(date))
  localLocale.locale(locale)
  return `${capitalizeFirstLetter(localLocale.format('MMMM'))} ${localLocale.format('YYYY')}`
}

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// const ImmunizationBox = ({data}) => {
//   console.log(data)
//   const pathologies = []
//   data.protocolInfo.forEach(info => pathologies.push(info.pathology.name))
//   console.log(pathologies)
//   return null
// }

const NextImmunoBox = ({data, locale, translate}) => {
  const formattedWithCurrentLocale = formatDate(data.date, locale)
  const formattedWithEnglishLocale = formatDate(data.date, 'en')
  return <div>
    <div className='uk-text-small'>{formattedWithCurrentLocale}</div>
    <div className='uk-text-xsmall uk-text-muted'>{formattedWithEnglishLocale}</div>
    <div className='next-pathologies-container'>
      {
        data.pathologies.map((pathology, i) => <div
          className='uk-text-small'
          key={i}>
          {translate(pathology, true, 'pathologies')}
        </div>)
      }
    </div>
  </div>
}

ReceiptContent.displayName = 'Receipt'

export default withPolyglot(ReceiptContent, 'receipt')
